import Cookies from "universal-cookie";

const setConexion = async (Direccion, Puerto) => {
  await localStorage.setItem("1ddir", Direccion);
  await localStorage.setItem("1dpto", Puerto);
};

const getAuthToken = async () => {
  const token = await localStorage.getItem("1dTkApp");
  return token;
};

const removeAuthToken = async () => {
  await localStorage.removeItem("1dTkApp");
};

const getConexion = () => {
  const Direccion = localStorage.getItem("1ddir");
  const Puerto = localStorage.getItem("1dpto");

  const Conexion = "http://" + Direccion + ":" + Puerto + "/";

  return Conexion;
};
/**
 * Obtiene el area registrado en el localstorage
 */
export const getArea = () => {
  return localStorage.getItem("CTSAID");
};
/**
 * Registrar el area al localstorage
 */
export const setArea = (area) => {
  localStorage.setItem("CTSAID", area);
};

//const VerifyConfig = async () => {
//  const res = await fetch("/config/config.json");
//  const datos = await res.json();//
//  if (datos) return datos;
//};

/**
 * 
 */
const getAreapCook = () => {
  let cookies = new Cookies();
  return cookies.get('Ctrpar');
};

const getProyCook = () => {
  let cookies = new Cookies();
  return cookies.get('Ctrprj');
};

//export const ObtenerURL = VerifyConfig().APP_URL;

export { getAuthToken, removeAuthToken, getConexion, setConexion, getAreapCook, getProyCook };
